import type { ComponentType } from 'react';

import { ChartIcon, DocumentIcon, ListIcon, PlusIcon, SettingsIcon } from './icons.tsx';

export type NavItem = {
  to: string;
  label: string;
  Icon: ComponentType<{ className?: string }>;
};

/**
 * Tab order is fixed. Log first — it is what the app is for. Settings last,
 * where every app puts it.
 *
 * Report earns a tab rather than living behind a card on the Dashboard, which
 * is where it was until 2026-08-23: it had no navigation entry at all, and a
 * trainee looking for the thing the whole app exists to produce could not find
 * it. Five tabs is the most this bar should ever carry — at 320px they are
 * already 64px wide.
 */
export const NAV_ITEMS: readonly NavItem[] = [
  { to: '/log', label: 'Log', Icon: PlusIcon },
  { to: '/entries', label: 'Entries', Icon: ListIcon },
  { to: '/dashboard', label: 'Dashboard', Icon: ChartIcon },
  { to: '/report', label: 'Report', Icon: DocumentIcon },
  { to: '/settings', label: 'Settings', Icon: SettingsIcon },
];
